import { ArchTopBoolean, WindowShapeTypes } from "building-types/settings/windowTypesEnum";
import type { GeneratedWindowPlacement, WindowDescriptor } from "building-types/windows/windowTypes";
import type { LevelInches } from "common/types/nominalNumbersTypes";
import { levelInchesNew } from "common/utils/nominalNumbers";

interface WindowArchProperties {
  readonly height: number;
  readonly arcAngle: number;
}

/**
 * Calculates the height of an arc given the width and radius. The returned arc angle is half the total arc (i.e. if
 * the width equals the radius, the arc angle will be 90 degrees).
 */
export function archPropertiesFromWidthRadius(width: number, radius: number | undefined): WindowArchProperties {
  const halfWidth = width / 2;
  const arcRadius = Math.max(radius ?? halfWidth, halfWidth); //the minimum allowed radius is half the width
  const arcAngle = Math.asin(halfWidth / arcRadius);
  const height = arcRadius * (1 - Math.cos(arcAngle));
  return { height, arcAngle };
}

export function windowHeadHeight(
  window: Pick<GeneratedWindowPlacement, "headHeight" | "verticalOffset" | "descriptor">,
): LevelInches {
  const { headHeight, verticalOffset, descriptor } = window;
  if (headHeight !== undefined) {
    return levelInchesNew(headHeight + verticalOffset);
  }
  return levelInchesNew(getWindowHeight(descriptor) + verticalOffset);
}

/** @todo (Andrew) - rework this to use profiles */
export function getWindowHeight(
  descriptor: Pick<WindowDescriptor, "shape" | "archRadius" | "archBoolean" | "height" | "width">,
): LevelInches {
  const { shape, archRadius, archBoolean, height, width } = descriptor;
  let finalHeight = height;
  if (shape === WindowShapeTypes.RECTANGLE_ARCHED_TOP && archBoolean === ArchTopBoolean.ADD) {
    const { height: archHeight } = archPropertiesFromWidthRadius(width, archRadius);
    finalHeight = levelInchesNew(finalHeight + archHeight);
  }
  return levelInchesNew(finalHeight);
}
